<template>
<div>
    <div class="footer">
		<!-- <div class="clearfix">
			<ul class="menu-list" v-for="cat in menuItems" v-bind:key="cat.index">
				<li class="footer-main-item"><router-link :to="cat.main.link">{{cat.main.text}}</router-link></li>
				<li class="footer-sub-item" v-for="item in cat.sub" v-bind:key="item.index">
					<router-link :to="item.link">{{ item.text }}</router-link>
				</li>
			</ul>
			<ul class="last-list">
				<li class="footer-main-item"><router-link to="/contact">Contact</router-link></li>
				<li class="footer-sub-item" style="font-weight: bold; line-height: 1.8;"><img :src="logo" width="30px" style="float: left; margin: 0 5px 0 0;"/>Herberg van het Hart</li>
				<li class="footer-sub-item">+31(0)6-53574848</li>
				<li class="footer-sub-item">suzette@herbergvanhethart.eu</li>
				<li class="footer-sub-item">Goudbaard 82, </li>
				<li class="footer-sub-item">4625GC, Bergen op Zoom</li>
			</ul>
		</div> -->
		<div style="text-align:center;margin:20px">
			<p class="footer-text">
				<a target="_blank" href="https://www.herbergvanhethart.eu/Privacyverklaring-Herberg-van-het-Hart-05-2018.pdf">Privacyverklaring</a>
				<a target="_blank" style="margin-left: 25px;" href="https://www.herbergvanhethart.eu/Algemene-voorwaarden-Herberg-van-het-Hart-05-2018.pdf">Algemene Voorwaarden</a>
			</p>
		</div>
    </div>
</div>
</template>

<script>
import {menuItems} from '../recourses/menu';

export default {
	name: 'footer',
	data() {
		return {
			menuItems: {},
			logo: require('../img/logo.png')
		};
	},
	computed: {
	},
	methods: {
	},
	components: {
	},
	beforeMount () {
		this.menuItems = JSON.parse(JSON.stringify(menuItems));
		delete this.menuItems.demo;
		delete this.menuItems.contact;
		delete this.menuItems.gameofgifts;
	}
};
</script>

<style lang="less">
@import "../styles/styles.less";

.footer-text {
	color: @gray-4;
	font-size: 11pt;
	font-weight: normal;
}
.footer {
	width: @container-width;
	margin-top: 20px;
	border-top: 2px solid @blue-4;
	padding-top: 20px;
	margin-left: auto;
    margin-right: auto;

}
.menu-list {
	float: left;
	margin-right: 24px;
	list-style-type: none;
}

.last-list {
	float: left;
	margin-right: 0;
	list-style-type: none;
}
.footer ul li {
	margin: 0;
	max-width: 250px;
	color: @gray-4;
	font-size: 10pt;
	font-weight: normal;
	padding-top: 5px;
	padding-bottom: 5px;
}

.footer a {
	text-decoration: none;
	color: @gray-4;
}

.footer-main-item {
	text-align: center;
	line-height: 2;
	font-size: 12pt !important;
	font-weight: bold !important;
}

.footer-sub-item
{
	border-top: 1px solid gray;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

</style>



// WEBPACK FOOTER //
// src/components/MainFooter.vue